import { sendRequest } from "@/shared/api/requestSender";
import { API_URL } from "@/shared/api/apiUrl";
import { HttpMethod } from "@/shared/types";

import { IGetManyMrnCategoriesParams } from "../model/types/interfaces";

export const sendCreateMrnCategoryRequest = (body: unknown) =>
  sendRequest({
    path: API_URL.mrnCategories.createOne,
    method: HttpMethod.POST,
    data: body,
  });

export const sendGetMrnCategoryRequest = (mrnCategoryId: number) =>
  sendRequest({ path: `${API_URL.mrnCategories.getOne}/${mrnCategoryId}`, method: HttpMethod.GET });

export const sendUpdateMrnCategoryRequest = (mrnCategoryId: number, body: unknown) =>
  sendRequest({ path: `${API_URL.mrnCategories.updateOne}/${mrnCategoryId}`, method: HttpMethod.PATCH, data: body });

export const sendDeleteMrnCategoryRequest = (mrnCategoryId: number) =>
  sendRequest({ path: `${API_URL.mrnCategories.deleteOne}/${mrnCategoryId}`, method: HttpMethod.DELETE });

export const sendGetManyMrnCategoriesRequest = (body: IGetManyMrnCategoriesParams) =>
  sendRequest({ path: API_URL.mrnCategories.getMany, method: HttpMethod.POST, data: body });

